import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {
	ChartWrapper,
	DashBoardDiv,
	GridItem,
	PieChartData,
	PieWrapper,
	StyledGrid,
	WaterfallWrapper,
} from '../FinanceReport.styles';
import { chartLightBlue } from 'styles/colors';

const DashBoardChart = props => {
	const { waterfallData, pieData, vendorCountData, savingData } = props;
	const options = {
		chart: {
			spacingTop: 20,
			backgroundColor: 'rgba(0,0,0,0)',
			style: {
				fontFamily: 'Roboto',
			},
			marginTop: 50,
			spacingBottom: 20,
			height: 400,
			events: {
				render() {
					const chart = this;

					// Get the last three points' shapes
					const series = chart.series[0];
					console.log(series.points);
					const lastThreePoints = series.points.slice(0, 3); // Last three points
					console.log(lastThreePoints);
					// Calculate the xMin and xMax (for the left and right edges of the last three bars)
					let xMin = Math.min(
						...lastThreePoints.map(point => point.shapeArgs.x)
					); // Leftmost point
					let xMax = Math.max(
						...lastThreePoints.map(
							point => point.shapeArgs.x + point.shapeArgs.width
						)
					); // Rightmost point

					// yMin is the topmost point of the tallest bar among the last three
					let yMin = Math.min(
						...lastThreePoints.map(point => point.shapeArgs.y)
					);

					// Get the pixel position of the X-axis (where Y = 0)
					let yAxisZero = chart.yAxis[0].toPixels(0); // Pixel position of Y = 0 (X-axis)

					// Remove previous boxes if they exist
					if (chart.customBox) {
						chart.customBox.destroy();
					}

					// Draw a new rectangle box around the last three bars, extending exactly to the X-axis
					chart.customBox = chart.renderer
						.rect(
							xMin + 54, // Start from the leftmost bar
							yMin + 35, // Top of the tallest bar
							xMax - xMin + 10, // Width from the leftmost to rightmost bar
							yAxisZero - yMin - 30 // Height from top of the bars down to the X-axis
						)
						.attr({
							stroke: chartLightBlue,
							'stroke-width': 1,
							fill: 'none',
							zIndex: 5,
						})
						.add();
				},
			},
		},

		title: {
			text: 'FINAL BASELINE BY ACTION',
			style: {
				fontWeight: 'bold',
				color: '#a4a4a6',
				textAlign: 'left',
			},
		},
		xAxis: {
			reversed: true,
			title: {
				text: '',
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: '#333333',
				},
			},
			lineColor: '#000000',
			labels: {
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: '#333333',
				},
			},
			gridLineWidth: 0,
			categories: [
				'Eliminate',
				'Reduce Demand',
				'Consolidate',
				'Continue to Use',
				'Actioned Baseline',
				'UnActioned Baseline',
				// '',
				'Intial Baseline Spend',
			],
		},
		yAxis: {
			title: {
				align: 'high',
				text: 'Spend',
				textAlign: 'right',
				rotation: 0,
				y: -10,
				offset: 15,
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: '#333333',
				},
			},
			gridLineWidth: 0,
			labels: {
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: '#333333',
				},
			},
			lineColor: '#000000',
			lineWidth: 1,
		},
		legend: {
			enabled: false,
			symbolRadius: 1,
			symbolHeight: 16,
			useHTML: true,
			itemMarginBottom: 12,
			itemStyle: {
				color: '#1A1A1A',
				cursor: 'pointer',
				fontSize: '11px',
				fontWeight: 'normal',
				textOverflow: 'ellipsis',
			},
		},
		credits: {
			enabled: false,
		},
		exporting: {
			enabled: false,
		},
		tooltip: {
			enabled: true,
			shared: true,
			distance: 56,
			useHTML: true,
			backgroundColor: 'rgba(255,255,255, 0.9)',
			borderWidth: 0,
			outside: true,
			borderRadius: 2,
		},
		plotOptions: {
			waterfall: {
				stacking: 'normal',
				borderWidth: 0,
				dataLabels: {
					enabled: false,
				},
			},
			series: {
				animation: true,
				stacking: 'normal',
				pointWidth: 50,
			},
		},
		series: [
			{
				type: 'waterfall',
				data: waterfallData,
			},
		],
	};
	const options1 = {
		chart: {
			spacingTop: 22,
			backgroundColor: 'rgba(0,0,0,0)',
			style: {
				fontFamily: 'Roboto',
			},
			marginTop: 40,
			spacingBottom: 20,
			height: 400,
		},
		title: {
			text: 'FINAL SAVINGS BY ACTION',
			style: {
				fontWeight: 'bold',
				color: '#a4a4a6',
				textAlign: 'left',
				x: 10,
				y: 50,
			},
		},
		xAxis: {
			reversed: true,
			title: {
				text: '',
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: '#333333',
				},
			},
			lineColor: '#000000',
			labels: {
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: '#333333',
				},
			},
			gridLineWidth: 0,
			categories: [
				'Facilities',
				'Transportation & Logistics',
				'Corporate Services',
				'MRO & Operating Supplies',
				'Industrial Services',
				'Equipment & Machinery',
				'Professional Services',
				'Marketing',
				'Information Technology',
				'Other Spend',
				'',
				'Total Spend',
			],
		},
		yAxis: {
			title: {
				align: 'high',
				text: 'Spend',
				textAlign: 'right',
				rotation: 0,
				y: -10,
				offset: 15,
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: '#333333',
				},
			},
			gridLineWidth: 0,
			labels: {
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: '#333333',
				},
			},
			lineColor: '#000000',
			lineWidth: 1,
		},
		legend: {
			enabled: false,
			symbolRadius: 1,
			symbolHeight: 16,
			useHTML: true,
			itemMarginBottom: 12,
			itemStyle: {
				color: '#1A1A1A',
				cursor: 'pointer',
				fontSize: '11px',
				fontWeight: 'normal',
				textOverflow: 'ellipsis',
			},
		},
		credits: {
			enabled: false,
		},
		exporting: {
			enabled: false,
		},
		tooltip: {
			enabled: true,
			shared: true,
			distance: 56,
			useHTML: true,
			backgroundColor: 'rgba(255,255,255, 0.9)',
			borderWidth: 0,
			outside: true,
			borderRadius: 2,
		},
		plotOptions: {
			waterfall: {
				stacking: 'normal',
				borderWidth: 0,
				dataLabels: {
					enabled: false,
				},
			},
			column: {},
			series: {
				animation: true,
				stacking: 'normal',
				pointPadding: 0,
				groupPadding: 0,
			},
		},
		series: [
			{
				type: 'pie',
				name: 'Total',
				data: pieData,
				size: 200,
				innerSize: '60%',
				showInLegend: false,
				dataLabels: {
					enabled: false,
				},
			},
		],
	};
	return (
		<DashBoardDiv>
			<ChartWrapper>
				<WaterfallWrapper>
					<HighchartsReact highcharts={Highcharts} options={options} />
					<div style={{ fontSize: '14px', marginLeft: '6%' }}>
						Number Of Vendor Records
					</div>
					<StyledGrid>
						{Object.values(vendorCountData).map((value, index) => (
							<GridItem key={index}>{value}</GridItem>
						))}
					</StyledGrid>
				</WaterfallWrapper>
				<PieWrapper>
					<HighchartsReact highcharts={Highcharts} options={options1} />
					<PieChartData>
						<div>{`${savingData[0]} (${savingData[1].toFixed(1)})%`}</div>
						<div>Identified Savings Opportunity </div>
					</PieChartData>
				</PieWrapper>
			</ChartWrapper>
		</DashBoardDiv>
	);
};

export default DashBoardChart;

// export default DashBoardChart;
